import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 md:pb-20">
        <div className="px-4 md:px-6 max-w-[800px] mx-auto">
          <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-900 cursor-pointer transition-colors">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700 font-medium">About Itaobuy Spreadsheet</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">La Nostra Missione</h1>

          <div className="space-y-6 text-foreground-700 leading-relaxed text-sm">
            <p>
              <strong>Itaobuy Spreadsheet</strong> è nato con un obiettivo chiaro: diventare il principale 
              hub italiano dedicato alla scoperta di prodotti cinesi di qualità. In un panorama dove lo 
              shopping internazionale può sembrare complicato e rischioso, noi offriamo una soluzione 
              semplice, organizzata e affidabile.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">La Missione del Sito</h2>
            <p>
              La nostra missione è democratizzare l&apos;accesso ai migliori prodotti dei marketplace cinesi, 
              fornendo agli utenti italiani uno strumento completo e facile da usare. Crediamo che chiunque, 
              indipendentemente dalla propria esperienza con lo shopping internazionale, debba poter 
              accedere a prodotti di qualità a prezzi convenienti.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Come Vengono Create le Guide</h2>
            <p>
              Ogni guida pubblicata sul nostro sito segue un processo editoriale rigoroso. Partiamo 
              dall&apos;esperienza diretta del nostro team, integriamo dati oggettivi raccolti attraverso 
              test e analisi, e produciamo contenuti originali in italiano. Non utilizziamo traduzioni 
              automatiche né copiamo contenuti da altri siti: ogni articolo è scritto dal nostro team 
              sulla base di conoscenze reali e verificate.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Come Vengono Aggiornati gli Articoli</h2>
            <p>
              Il mondo dei marketplace cinesi è in continua evoluzione: nuovi venditori, prodotti, 
              tendenze e politiche emergono costantemente. Per questo motivo, aggiorniamo i nostri 
              contenuti con una frequenza minima di 60 giorni. Ogni articolo riporta la data dell&apos;ultimo 
              aggiornamento, così puoi sempre sapere quanto sono fresche le informazioni che stai leggendo.
            </p>

            <div className="mt-10 p-5 bg-background-100 rounded-xl">
              <h3 className="font-semibold text-foreground-900 mb-2">I Nostri Valori</h3>
              <ul className="space-y-2 text-sm">
                <li><strong>Trasparenza:</strong> Mostriamo sempre foto reali (QC) e prezzi aggiornati.</li>
                <li><strong>Affidabilità:</strong> Verifichiamo ogni prodotto prima di consigliarlo.</li>
                <li><strong>Accessibilità:</strong> Rendiamo semplice ciò che sembra complicato.</li>
                <li><strong>Comunità:</strong> Ascoltiamo e coinvolgiamo attivamente i nostri utenti.</li>
              </ul>
            </div>

            <div className="mt-8">
              <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors">
                &larr; Torna alla Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: 'La Nostra Missione - Itaobuy Spreadsheet',
            url: 'https://itaobuyspread.pics/about-itaobuy-spreadsheet',
            description: 'Itaobuy Spreadsheet è il principale hub italiano dedicato alla scoperta di prodotti cinesi di qualità. La nostra missione è democratizzare l\'accesso ai migliori prodotti dei marketplace cinesi.',
            inLanguage: 'it',
            about: {
              '@type': 'Organization',
              name: 'Itaobuy Spreadsheet',
            },
          }),
        }}
      />
    </>
  );
}